
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/softcover-book",
      function () {
        return require("private-next-pages/shop/softcover-book.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/softcover-book"])
      });
    }
  